/* =========================================================
   MisjaSucho — quiz.js
   Vanilla quiz engine driven by section JSON config.
   Each option carries `tags`; outcomes match against the
   union of picked tags via match_all / match_any / match_none.
   Renders progress, options, result with bundle + supporting
   products. Uses /cart/add.js to add the bundle when chosen.
   ========================================================= */

(function () {
  const T = window.theme || {};
  const sections = document.querySelectorAll('[data-quiz]');
  sections.forEach(initQuiz);

  function initQuiz(root) {
    const cfgEl = root.querySelector('[data-quiz-config]');
    if (!cfgEl) return;
    let cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[quiz] bad config', e); return; }

    const mount = root.querySelector('[data-quiz-mount]');
    if (!mount) return;
    if (!cfg.questions || !cfg.questions.length) {
      mount.innerHTML = `<div class="card" style="padding:24px"><p class="muted">Quiz nie ma jeszcze pytań. Dodaj bloki „Pytanie” w edytorze sekcji.</p></div>`;
      return;
    }

    const state = { step: 0, answers: {} };

    function go() {
      const done = state.step >= cfg.questions.length;
      mount.innerHTML = done ? renderResult() : renderStep();
      bind();
      mount.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function pickedTags() {
      const tags = new Set();
      cfg.questions.forEach((q) => {
        const v = state.answers[q.id];
        if (!v) return;
        const vals = Array.isArray(v) ? v : [v];
        vals.forEach((val) => {
          const opt = q.opts.find((o) => o.v === val);
          if (opt && opt.tags) opt.tags.split(',').map(s => s.trim()).filter(Boolean).forEach(t => tags.add(t));
        });
      });
      return tags;
    }

    function recommend() {
      const tags = pickedTags();
      const match = (csv, fn) => {
        const arr = String(csv || '').split(',').map(s => s.trim()).filter(Boolean);
        if (!arr.length) return null;
        return fn(arr);
      };
      for (const o of cfg.outcomes) {
        const all  = match(o.matchAll,  (a) => a.every(t => tags.has(t)));
        const any  = match(o.matchAny,  (a) => a.some(t => tags.has(t)));
        const none = match(o.matchNone, (a) => a.every(t => !tags.has(t)));
        if (all === false || any === false || none === false) continue;
        if (all === null && any === null && none === null) continue; // fallthrough — keep looking unless this is the default
        return o;
      }
      // default: first outcome with no conditions
      return cfg.outcomes.find(o => !o.matchAll && !o.matchAny && !o.matchNone) || cfg.outcomes[0] || null;
    }

    function svg(name, size = 18) {
      const map = {
        sparkle: '<path d="M12 3v5M12 16v5M3 12h5M16 12h5M6 6l3 3M15 15l3 3M18 6l-3 3M9 15l-3 3"/>',
        arrow:   '<path d="M5 12h14M13 6l6 6-6 6"/>',
        arrowL:  '<path d="M19 12H5M11 6l-6 6 6 6"/>',
        check:   '<path d="M20 6 9 17l-5-5"/>',
        refresh: '<path d="M3 12a9 9 0 0 1 15-6.7L21 8M21 3v5h-5M21 12a9 9 0 0 1-15 6.7L3 16M3 21v-5h5"/>',
        feather: '<path d="M20 4a6 6 0 0 0-8.5 0L4 11.5V20h8.5L20 12.5A6 6 0 0 0 20 4z"/><path d="M16 8 6 18M12 8h.01M16 12H10"/>',
        drop:    '<path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z"/>',
        shield:  '<path d="M12 3 5 6v5c0 4.4 3 7.6 7 9 4-1.4 7-4.6 7-9V6z"/><path d="m9 12 2 2 4-4"/>',
        work:    '<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>',
        run:     '<circle cx="14" cy="5" r="2"/><path d="M9 21l2-5 3 2v4M11 16l-1-4 4-2 3 3h3M7 11l3-3"/>',
        plane:   '<path d="M2 13l8-2 4-8 2 1-2 8 6 3-1 2-7-2-3 5-2-1 1-5z"/>',
        moon:    '<path d="M20 14.5A8 8 0 1 1 9.5 4 6.5 6.5 0 0 0 20 14.5z"/>',
        sun:     '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M2 12h2M20 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4"/>',
        heart:   '<path d="M12 20s-7-4.6-9.3-9A4.6 4.6 0 0 1 12 6a4.6 4.6 0 0 1 9.3 5c-2.3 4.4-9.3 9-9.3 9z"/>',
        user:    '<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>',
        close:   '<path d="M6 6 18 18M18 6 6 18"/>',
        leaf:    '<path d="M11 20A7 7 0 0 1 4 13c0-5 4-9 16-9 0 8-4 12-9 12z"/><path d="M4 20c4-7 8-9 12-10"/>',
        package2:'<path d="M16.5 9.4 7.5 4.2M3.3 7.3 12 12l8.7-4.7M12 22V12"/><path d="M21 16V8a2 2 0 0 0-1-1.7l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.7l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>',
      };
      const inner = map[name] || '<circle cx="12" cy="12" r="9"/>';
      return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${inner}</svg>`;
    }

    function renderStep() {
      const q = cfg.questions[state.step];
      const total = cfg.questions.length;
      const pct = Math.round((state.step / total) * 100);
      const v = state.answers[q.id];
      const sel = (val) => q.multi ? Array.isArray(v) && v.includes(val) : v === val;
      const canNext = q.multi ? Array.isArray(v) && v.length > 0 : !!v;

      const opts = q.opts.map((o) => {
        const isSel = sel(o.v);
        const left = q.multi
          ? `<span class="chk">${isSel ? svg('check', 14) : ''}</span>`
          : `<span class="opt-emoji">${svg(o.icon || 'check', 18)}</span>`;
        const subHtml = o.sub ? `<span>${escapeHtml(o.sub)}</span>` : '';
        return `<button class="opt ${isSel ? 'sel' : ''}" data-pick="${escapeAttr(o.v)}" type="button">
          ${left}
          <span class="opt-txt"><b>${escapeHtml(o.label)}</b>${subHtml}</span>
        </button>`;
      }).join('');

      const helpHtml = (q.multi ? (q.help || cfg.select_multi_help) : q.help) || '';
      const isBackDisabled = state.step === 0;

      return `
        <div class="quiz-progress"><i style="width:${pct}%"></i></div>
        <div class="row" style="justify-content:space-between">
          <span class="quiz-step-no">${cfg.step_of.replace('{{ current }}', state.step + 1).replace('{{ total }}', total)}</span>
          ${cfg.exit_url ? `<a class="btn btn-ghost btn-sm" href="${cfg.exit_url}" style="color:var(--muted)">${escapeHtml(cfg.skip)}</a>` : ''}
        </div>
        <h1 class="quiz-q">${escapeHtml(q.q)}</h1>
        ${helpHtml ? `<p class="muted">${escapeHtml(helpHtml)}</p>` : ''}
        <div class="opt-grid ${q.opts.length > 3 ? 'cols-2' : ''}">${opts}</div>
        <div class="quiz-nav">
          <button class="btn btn-secondary" data-back type="button" ${isBackDisabled ? 'disabled style="opacity:.4"' : ''}>
            ${svg('arrowL', 16)} ${escapeHtml(cfg.back)}
          </button>
          ${q.multi
            ? `<button class="btn btn-primary" data-next type="button" ${canNext ? '' : 'disabled style="opacity:.5"'}>${escapeHtml(cfg.next)} ${svg('arrow', 16)}</button>`
            : `<span class="small muted">${escapeHtml(cfg.select_to_continue)}</span>`}
        </div>
      `;
    }

    function renderResult() {
      const out = recommend();
      const reason = (out && out.reason) || cfg.default_reason;
      let bundle = null;
      if (out && out.bundleHandle) bundle = cfg.bundles[out.bundleHandle];
      if (!bundle && cfg.default_bundle_handle) bundle = cfg.bundles[cfg.default_bundle_handle];

      const handles = (out && out.productHandles) ? out.productHandles.split(',').map(s => s.trim()).filter(Boolean) : [];
      const supporting = handles.map(h => cfg.products[h]).filter(Boolean);

      const bundleHtml = bundle ? `
        <div class="card" style="display:grid;grid-template-columns:1fr 1fr;overflow:hidden;margin-top:40px">
          <a href="${bundle.url}" class="ph ph-center" style="min-height:280px;--ph-tint:${bundle.tint}">
            ${bundle.image ? `<img src="${bundle.image}" alt="${escapeAttr(bundle.title)}" loading="lazy" sizes="(min-width:980px) 50vw, 100vw">` : '<span class="ph-label">zestaw</span>'}
          </a>
          <div style="padding:clamp(24px,3vw,40px);display:flex;flex-direction:column;justify-content:center;gap:12px">
            <span class="pill" style="align-self:flex-start">${svg('check', 14)} ${escapeHtml(cfg.result_best_match)}</span>
            <h2 class="h-lg">${escapeHtml(bundle.title)}</h2>
            <p class="muted">${escapeHtml(bundle.description || '')}</p>
            <div class="row gap-12">
              <span class="price" style="font-size:24px">${money(bundle.price)}</span>
              ${bundle.compareAt > bundle.price ? `<span class="price-was">${money(bundle.compareAt)}</span>` : ''}
            </div>
            <div class="row gap-12 wrap" style="margin-top:6px">
              <button class="btn btn-primary btn-lg" data-add-bundle data-variant-id="${bundle.variantId}">${escapeHtml(cfg.result_add_to_cart)}</button>
              <a class="btn btn-secondary" href="${bundle.url}">${escapeHtml(cfg.result_view_bundle)}</a>
            </div>
          </div>
        </div>` : (cfg.default_collection_url ? `
        <div class="card" style="padding:32px;margin-top:40px;text-align:center">
          <p class="lead">${escapeHtml(reason)}</p>
          <a class="btn btn-primary btn-lg mt-16" href="${cfg.default_collection_url}">Przejdź do sklepu</a>
        </div>` : '');

      const supportingHtml = supporting.length ? `
        <div style="margin-top:48px">
          <div class="sec-head">
            <div>
              <div class="eyebrow" style="margin-bottom:12px">${escapeHtml(cfg.result_singles_eyebrow)}</div>
              <h2 class="h-lg">${escapeHtml(cfg.result_singles_title)}</h2>
            </div>
          </div>
          <div class="grid grid-3">
            ${supporting.map(p => `
              <article class="pcard">
                <a class="ph ph-center" href="${p.url}" style="--ph-tint:var(--surface-2)">
                  ${p.image ? `<img src="${p.image}" alt="${escapeAttr(p.title)}" loading="lazy">` : '<span class="ph-label">zdjęcie produktu</span>'}
                </a>
                <div class="pcard-body">
                  <span class="pcard-cat">${escapeHtml(p.category || '')}</span>
                  <a class="pcard-name" href="${p.url}">${escapeHtml(p.title)}</a>
                  <div class="pcard-foot">
                    <span class="price">${money(p.price)}</span>
                    ${p.available ? `<button class="btn btn-secondary btn-sm" data-add-product data-variant-id="${p.variantId}">+ Dodaj</button>` : ''}
                  </div>
                </div>
              </article>
            `).join('')}
          </div>
        </div>` : '';

      return `
        <div class="container" style="max-width:980px;margin-inline:auto">
          <div class="center" style="max-width:620px;margin-inline:auto">
            <span class="opt-emoji" style="width:56px;height:56px;margin:0 auto 14px">${svg('sparkle', 24)}</span>
            <div class="eyebrow" style="justify-content:center;margin-bottom:12px">${escapeHtml(cfg.result_eyebrow)}</div>
            <h1 class="h-xl">${escapeHtml(cfg.result_title)}</h1>
            <p class="lead" style="margin-top:14px">${escapeHtml(reason)}</p>
          </div>
          ${bundleHtml}
          ${supportingHtml}
          <div class="center" style="margin-top:40px">
            <button class="btn btn-ghost" data-restart type="button">${svg('refresh', 16)} ${escapeHtml(cfg.restart)}</button>
          </div>
        </div>
      `;
    }

    function bind() {
      mount.querySelectorAll('[data-pick]').forEach((b) => {
        b.addEventListener('click', () => {
          const q = cfg.questions[state.step];
          const v = b.dataset.pick;
          if (q.multi) {
            const cur = state.answers[q.id] || [];
            state.answers[q.id] = cur.includes(v) ? cur.filter(x => x !== v) : [...cur, v];
            go();
          } else {
            state.answers[q.id] = v;
            setTimeout(() => { state.step += 1; go(); }, 200);
          }
        });
      });
      const next = mount.querySelector('[data-next]');
      if (next) next.addEventListener('click', () => { state.step += 1; go(); });
      const back = mount.querySelector('[data-back]');
      if (back) back.addEventListener('click', () => { state.step = Math.max(0, state.step - 1); go(); });
      const restart = mount.querySelector('[data-restart]');
      if (restart) restart.addEventListener('click', () => { state.step = 0; state.answers = {}; go(); });

      const addBundle = mount.querySelector('[data-add-bundle]');
      if (addBundle) addBundle.addEventListener('click', () => addToCart(addBundle.dataset.variantId, true));
      mount.querySelectorAll('[data-add-product]').forEach((b) => {
        b.addEventListener('click', () => addToCart(b.dataset.variantId, false));
      });
    }

    async function addToCart(variantId, goToCart) {
      try {
        const res = await fetch(`${T.rootUrl}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        });
        if (!res.ok) throw new Error('add failed');
        const j = await res.json();
        if (window.MSToast) window.MSToast(`Dodano: ${(j.items && j.items[0]?.product_title) || 'produkt'}`);
        if (goToCart) window.location.href = T.cartUrl;
      } catch (e) {
        console.warn('[quiz] add', e);
        if (window.MSToast) window.MSToast('Nie udało się dodać produktu');
      }
    }

    function money(cents) {
      const v = (cents / 100).toFixed(2).replace('.', ',');
      return `${v} zł`;
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function escapeAttr(s) { return escapeHtml(s); }

    go();
  }
})();
